import React from "react";
import { Link as RouterLink, useRouteMatch } from "react-router-dom";
import { RiSearch2Line, RiArrowRightLine } from "react-icons/ri";
import { useCategories } from "../../hooks/useCategories";
import { logEvent } from "../../helpers/analytics";

export const HeroSectionCTAV2 = () => {
  const match = useRouteMatch();
  const { categories, loading } = useCategories();

  // const otherCategory = categories?.find(
  //   (category) => category.name === "Other"
  // );

  const prioritySortedNonOtherCategories = categories
    ?.slice()
    .sort((a, b) => b.priority - a.priority)
    .filter((category) => category.name !== "Other")
    .slice(0, 4);

  if (loading) {
    return (
      <div className="w-full max-w-4xl mx-auto flex flex-col items-center gap-7">
        {/* Loading search bar */}
        <div className="w-full">
          <div className="relative w-full h-17 bg-gray-300 animate-pulse border border-gray-200"></div>
        </div>
        {/* Loading category buttons */}
        <div className="flex flex-wrap gap-6 justify-center">
          {new Array(4).fill(0).map((_, index) => (
            <div key={index} className="w-32 h-14 bg-gray-300 animate-pulse border border-gray-200"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="w-full lg:w-[47vw] flex flex-col items-start gap-4 md:gap-7">
      {/* Search Bar */}
      <div className="w-full">
        <RouterLink
          to={`${match.path}/hire/new`}
          onClick={() => {
            logEvent("hero_section_cta_search_clicked");
            logEvent("homeowner_hire_workflow_started");
          }}
          className="block w-full"
        >
          <div className="relative w-full h-17 border border-[#F4F4F4] flex items-center rounded-none">
            {/* Search input area */}
            <div className="flex-1 flex items-center px-3 md:px-[18px] py-2 md:py-[18px]">
              <RiSearch2Line className="w-4 h-4 md:w-5 md:h-5 text-[#E0E0E0] mr-2 md:mr-4" />
              <span className="text-sm md:text-xl font-normal text-[#E0E0E0] font-[Inter] leading-[1.6]">
                What do you want to search for?
              </span>
            </div>
            {/* Search button */}
            <div className="w-[80px] md:w-[131px] h-[66px] bg-[#F4F4F4] border border-[#F4F4F4] flex items-center justify-center">
              <span className="text-sm md:text-xl font-medium text-[#121212] font-[Inter] leading-[1.25]">
                Search
              </span>
            </div>
          </div>
        </RouterLink>
      </div>

      {/* Category Buttons */}
      <div className="flex flex-wrap gap-2 md:gap-6 justify-start">
        {prioritySortedNonOtherCategories?.map((category) => (
          <RouterLink
            key={category.id}
            to={`${match.path}/hire/new?category=${category.id}`}
            onClick={() => {
              logEvent("hero_section_cta_category_clicked", {
                category: category.name,
              });
              logEvent("homeowner_hire_workflow_started", {
                category: category.name,
              });
            }}
            className="group"
          >
            <div className="h-10 md:h-14 border border-[#E0E0E0] px-3 md:px-5 py-2 md:py-4 flex items-center justify-between hover:bg-[#cfcfcf] transition-colors rounded-none">
              <span className="text-sm md:text-lg font-medium text-[#E0E0E0] font-[Inter] leading-[1.333] group-hover:text-[#5a5a5a] whitespace-nowrap">
                {category.proTitle}
              </span>
              <RiArrowRightLine className="w-3 h-3 md:w-[18px] md:h-[18px] text-[#E0E0E0] ml-1 md:ml-2 group-hover:text-[#5a5a5a]" />
            </div>
          </RouterLink>
        ))}
      </div>
    </div>
  );
};
